import {
  isSmallScreen,
  isNewTouchDevice,
  isTouchDevice,
  isiOS,
  isAndroid,
  isChromebook,
  isChrome,
  deviceCheck
} from "../ui/utils/browser";

const methodMap = {
  isSmallScreen,
  isNewTouchDevice,
  isTouchDevice,
  isiOS,
  isAndroid,
  isChromebook,
  isChrome,
  deviceCheck
};

const Browser = {};

Object.keys(methodMap).forEach(name => {
  Browser[name] = methodMap[name];
});

module.exports = Browser;
